// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"152":"fd2d8ab4","199":"92b67751","701":"26dcb1b1","925":"3c091391","988":"b3b817bf"}[chunkId] + ".css";
};